import { B2BOPTIONS } from "./b2boptions";
import { FIRSTUPSELLOPTIONS } from "./firstUpsell";
import { SECONDUPSELLOPTIONS } from "./secondUpsellDefault";

const FIRSTTIMEPERSONAOPTIONS = {
  nudgeOfferText: {
    optionName: "Nudge offer Text",
    optionValue: "nudgeOfferText",
    customizeProperties: {
      text: {
        propertyName: "Text",
        propertyType: "text",
        propertyMaxLength: "150",
        propertyValue:
          "Get an exclusive 10% off if you order in next",
      },
      textColor: {
        propertyName: "Text-Color",
        propertyType: "color",
        propertyValue: "#000000",
      },
      fontStyle: {
        propertyName: "Font-Style",
        propertyType: "select",
        propertyValue: "normal",
        propertyOptions: [
          {
            optionName: "Normal",
            optionValue: "normal",
          },
          {
            optionName: "Italic",
            optionValue: "italic",
          },
          {
            optionName: "Oblique",
            optionValue: "oblique",
          },
        ],
      },
      isExpiryTimer: {
        propertyName: "Expiry Timer",
        propertyType: "checkbox",
        propertyValue: false,
      },
      minutes: {
        propertyName: "Minutes",
        propertyType: "text",
        propertyValue: "60",
      },
    },
  },
  nudgeCouponCode: {
    optionName: "Nudge coupon code",
    optionValue: "nudgeCouponCode",
    customizeProperties: {
      text: {
        propertyName: "Text",
        propertyType: "text",
        propertyMaxLength: "20",
        propertyValue: "CFWELCOME23",
      },
      textColor: {
        propertyName: "Text-Color",
        propertyType: "color",
        propertyValue: "#990505",
      },
      backgroundColor: {
        propertyName: "Background-Color",
        propertyType: "color",
        propertyValue: "#ffffff",
      },
      fontStyle: {
        propertyName: "Font-Style",
        propertyType: "select",
        propertyValue: "normal",
        propertyOptions: [
          {
            optionName: "Normal",
            optionValue: "normal",
          },
          {
            optionName: "Italic",
            optionValue: "italic",
          },
          {
            optionName: "Oblique",
            optionValue: "oblique",
          },
        ],
      },
      borderStyle: {
        propertyName: "Border-Style",
        propertyType: "select",
        propertyValue: "solid",
        propertyOptions: [
          {
            optionName: "None",
            optionValue: "none",
          },
          {
            optionName: "Dotted",
            optionValue: "dotted",
          },
          {
            optionName: "Dashed",
            optionValue: "dashed",
          },
          {
            optionName: "Solid",
            optionValue: "solid",
          },
        ],
      },
      borderColor: {
        propertyName: "Border-Color",
        propertyType: "color",
        propertyValue: "#ffffff",
      },
      borderWidth: {
        propertyName: "Border-Width",
        propertyType: "number",
        propertyValue: 0,
      },
    },
  },
  nudgeCopyCode: {
    optionName: "Nudge Copy code",
    optionValue: "nudgeCopyCode",
    customizeProperties: {
      text: {
        propertyName: "Text",
        propertyType: "text",
        propertyMaxLength: "50",
        propertyValue: "COPY CODE",
      },
      textColor: {
        propertyName: "Text-Color",
        propertyType: "color",
        propertyValue: "#ffffff",
      },
      backgroundColor: {
        propertyName: "Background-Color",
        propertyType: "color",
        propertyValue: "#000000",
      },
      fontStyle: {
        propertyName: "Font-Style",
        propertyType: "select",
        propertyValue: "normal",
        propertyOptions: [
          {
            optionName: "Normal",
            optionValue: "normal",
          },
          {
            optionName: "Italic",
            optionValue: "italic",
          },
          {
            optionName: "Oblique",
            optionValue: "oblique",
          },
        ],
      },
      borderStyle: {
        propertyName: "Border-Style",
        propertyType: "select",
        propertyValue: "solid",
        propertyOptions: [
          {
            optionName: "None",
            optionValue: "none",
          },
          {
            optionName: "Dotted",
            optionValue: "dotted",
          },
          {
            optionName: "Dashed",
            optionValue: "dashed",
          },
          {
            optionName: "Solid",
            optionValue: "solid",
          },
        ],
      },
      borderWidth: {
        propertyName: "Border-Width",
        propertyType: "number",
        propertyValue: 0,
      },
      borderColor: {
        propertyName: "Border-Color",
        propertyType: "color",
        propertyValue: "#ffffff",
      },
    },
  },
  nudge: {
    optionName: "Nudge",
    optionValue: "nudge",
    customizeProperties: {
      backgroundColor: {
        propertyName: "Background-Color",
        propertyType: "color",
        propertyValue: "#fff000",
      },
      borderColor: {
        propertyName: "Border-Color",
        propertyType: "color",
        propertyValue: "#ffffff",
      },
      borderStyle: {
        propertyName: "Border-Style",
        propertyType: "select",
        propertyValue: "solid",
        propertyOptions: [
          {
            optionName: "None",
            optionValue: "none",
          },
          {
            optionName: "Dotted",
            optionValue: "dotted",
          },
          {
            optionName: "Dashed",
            optionValue: "dashed",
          },
          {
            optionName: "Solid",
            optionValue: "solid",
          },
        ],
      },
      borderWidth: {
        propertyName: "Border-Width",
        propertyType: "number",
        propertyValue: 0,
      },
    },
    nudgePosition: {
      optionName: "Nudge Position",
      optionValue: "nudgePosition",
      desktop: {
        top: 0,
        left: 0,
      },
      mobile: {
        top: 0,
      },
    },
  },
  nudgeMinimize: {
    optionName: "Nudge Minimize",
    optionValue: "nudgeMinimize",
    customizeProperties: {
      enableMinimize: {
        propertyName: "Enable Minimize",
        propertyType: "select",
        propertyValue: "no",
        propertyOptions: [
          { optionName: "Yes", optionValue: "yes" },
          { optionName: "No", optionValue: "no" },
        ],
      },
      minimizePosition: {
        propertyName: "Minimize Position",
        propertyType: "select",
        propertyValue: "bottom-right",
        propertyOptions: [
          { optionName: "Bottom Left", optionValue: "bottom-left" },
          { optionName: "Bottom Center", optionValue: "bottom-center" },
          { optionName: "Bottom Right", optionValue: "bottom-right" },
        ],
      },
      minimizedLabel: {
        propertyName: "Minimized Label",
        propertyType: "text",
        propertyMaxLength: "30",
        propertyValue: "Offer",
      },
      pillBackgroundColor: {
        propertyName: "Pill Background Color",
        propertyType: "color",
        propertyValue: "#7c3aed",
      },
      pillBorderColor: {
        propertyName: "Pill Border Color",
        propertyType: "color",
        propertyValue: "#a78bfa",
      },
      pillBorderWidth: {
        propertyName: "Pill Border Width",
        propertyType: "number",
        propertyValue: 2,
      },
      pillAnimation: {
        propertyName: "Pill Animation",
        propertyType: "select",
        propertyValue: "pulse",
        propertyOptions: [
          { optionName: "Pulse", optionValue: "pulse" },
          { optionName: "Bounce", optionValue: "bounce" },
          { optionName: "Glow", optionValue: "glow" },
          { optionName: "Slide", optionValue: "slide" },
          { optionName: "None", optionValue: "none" },
        ],
      },
    },
  },
};

const EXPLORATORYPERSONAOPTIONS = {
  nudgeData: {
    nudgeOfferText: {
      optionName: "Nudge offer Text",
      optionValue: "nudgeOfferText",
      customizeProperties: {
        text: {
          propertyName: "Text",
          propertyType: "text",
          propertyMaxLength: "150",
          propertyValue:
            "Get an exclusive 10% off if you order in next",
        },
        textColor: {
          propertyName: "Text-Color",
          propertyType: "color",
          propertyValue: "#000000",
        },
        fontStyle: {
          propertyName: "Font-Style",
          propertyType: "select",
          propertyValue: "normal",
          propertyOptions: [
            {
              optionName: "Normal",
              optionValue: "normal",
            },
            {
              optionName: "Italic",
              optionValue: "italic",
            },
            {
              optionName: "Oblique",
              optionValue: "oblique",
            },
          ],
        },
        isExpiryTimer: {
          propertyName: "Expiry Timer",
          propertyType: "checkbox",
          propertyValue: false,
        },
        minutes: {
          propertyName: "Minutes",
          propertyType: "text",
          propertyValue: "60",
        },
      },
    },
    nudgeCouponCode: {
      optionName: "Nudge coupon code",
      optionValue: "nudgeCouponCode",
      customizeProperties: {
        text: {
          propertyName: "Text",
          propertyType: "text",
          propertyMaxLength: "20",
          propertyValue: "CFWELCOME23",
        },
        textColor: {
          propertyName: "Text-Color",
          propertyType: "color",
          propertyValue: "#990505",
        },
        backgroundColor: {
          propertyName: "Background-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        fontStyle: {
          propertyName: "Font-Style",
          propertyType: "select",
          propertyValue: "normal",
          propertyOptions: [
            {
              optionName: "Normal",
              optionValue: "normal",
            },
            {
              optionName: "Italic",
              optionValue: "italic",
            },
            {
              optionName: "Oblique",
              optionValue: "oblique",
            },
          ],
        },
        borderStyle: {
          propertyName: "Border-Style",
          propertyType: "select",
          propertyValue: "solid",
          propertyOptions: [
            {
              optionName: "None",
              optionValue: "none",
            },
            {
              optionName: "Dotted",
              optionValue: "dotted",
            },
            {
              optionName: "Dashed",
              optionValue: "dashed",
            },
            {
              optionName: "Solid",
              optionValue: "solid",
            },
          ],
        },
        borderColor: {
          propertyName: "Border-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        borderWidth: {
          propertyName: "Border-Width",
          propertyType: "number",
          propertyValue: 0,
        },
      },
    },
    nudgeCopyCode: {
      optionName: "Nudge Copy code",
      optionValue: "nudgeCopyCode",
      customizeProperties: {
        text: {
          propertyName: "Text",
          propertyType: "text",
          propertyMaxLength: "50",
          propertyValue: "COPY CODE",
        },
        textColor: {
          propertyName: "Text-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        backgroundColor: {
          propertyName: "Background-Color",
          propertyType: "color",
          propertyValue: "#000000",
        },
        fontStyle: {
          propertyName: "Font-Style",
          propertyType: "select",
          propertyValue: "normal",
          propertyOptions: [
            {
              optionName: "Normal",
              optionValue: "normal",
            },
            {
              optionName: "Italic",
              optionValue: "italic",
            },
            {
              optionName: "Oblique",
              optionValue: "oblique",
            },
          ],
        },
        borderStyle: {
          propertyName: "Border-Style",
          propertyType: "select",
          propertyValue: "solid",
          propertyOptions: [
            {
              optionName: "None",
              optionValue: "none",
            },
            {
              optionName: "Dotted",
              optionValue: "dotted",
            },
            {
              optionName: "Dashed",
              optionValue: "dashed",
            },
            {
              optionName: "Solid",
              optionValue: "solid",
            },
          ],
        },
        borderWidth: {
          propertyName: "Border-Width",
          propertyType: "number",
          propertyValue: 0,
        },
        borderColor: {
          propertyName: "Border-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
      },
    },
    nudge: {
      optionName: "Nudge",
      optionValue: "nudge",
      customizeProperties: {
        backgroundColor: {
          propertyName: "Background-Color",
          propertyType: "color",
          propertyValue: "#fff000",
        },
        borderColor: {
          propertyName: "Border-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        borderStyle: {
          propertyName: "Border-Style",
          propertyType: "select",
          propertyValue: "solid",
          propertyOptions: [
            {
              optionName: "None",
              optionValue: "none",
            },
            {
              optionName: "Dotted",
              optionValue: "dotted",
            },
            {
              optionName: "Dashed",
              optionValue: "dashed",
            },
            {
              optionName: "Solid",
              optionValue: "solid",
            },
          ],
        },
        borderWidth: {
          propertyName: "Border-Width",
          propertyType: "number",
          propertyValue: 0,
        },
      },
      nudgePosition: {
        optionName: "Nudge Position",
        optionValue: "nudgePosition",
        desktop: {
          top: 0,
          left: 0,
        },
        mobile: {
          top: 0,
        },
      },
    },
    nudgeMinimize: {
      optionName: "Nudge Minimize",
      optionValue: "nudgeMinimize",
      customizeProperties: {
        enableMinimize: {
          propertyName: "Enable Minimize",
          propertyType: "select",
          propertyValue: "no",
          propertyOptions: [
            { optionName: "Yes", optionValue: "yes" },
            { optionName: "No", optionValue: "no" },
          ],
        },
        minimizePosition: {
          propertyName: "Minimize Position",
          propertyType: "select",
          propertyValue: "bottom-right",
          propertyOptions: [
            { optionName: "Bottom Left", optionValue: "bottom-left" },
            { optionName: "Bottom Center", optionValue: "bottom-center" },
            { optionName: "Bottom Right", optionValue: "bottom-right" },
          ],
        },
        minimizedLabel: {
          propertyName: "Minimized Label",
          propertyType: "text",
          propertyMaxLength: "30",
          propertyValue: "Offer",
        },
        pillBackgroundColor: {
          propertyName: "Pill Background Color",
          propertyType: "color",
          propertyValue: "#7c3aed",
        },
        pillBorderColor: {
          propertyName: "Pill Border Color",
          propertyType: "color",
          propertyValue: "#a78bfa",
        },
        pillBorderWidth: {
          propertyName: "Pill Border Width",
          propertyType: "number",
          propertyValue: 2,
        },
        pillAnimation: {
          propertyName: "Pill Animation",
          propertyType: "select",
          propertyValue: "pulse",
          propertyOptions: [
            { optionName: "Pulse", optionValue: "pulse" },
            { optionName: "Bounce", optionValue: "bounce" },
            { optionName: "Glow", optionValue: "glow" },
            { optionName: "Slide", optionValue: "slide" },
            { optionName: "None", optionValue: "none" },
          ],
        },
      },
    },
  },
  userTraffic: {
    referrerSites:[],
    URLqueryParams: [],
  },
}

export const OPTIONS = {
  firstTimePersonaNudge: { ...FIRSTTIMEPERSONAOPTIONS },
  b2BPersonaNudge: { ...B2BOPTIONS },
  firstUpsellNudge: { ...FIRSTUPSELLOPTIONS },
  secondUpsellNudge: { ...SECONDUPSELLOPTIONS },
};



export const allPersonaTypes = [
  {
    optionName: "First Time",
    optionValue: "firstTimePersonaNudge",
  },
  {
    optionName: "Exploratory",
    optionValue: "exploratoryPersonaNudge",
  },
  {
    optionName: "Upsell",
    optionValue: "upsellPersonaNudge",
  },
  {
    optionName: "Upsell 2",
    optionValue: "upsell2PersonaNudge",
  },
  {
    optionName: "B2B",
    optionValue: "b2BPersonaNudge",
  },
  {
    optionName: "Free Shipping",
    optionValue: "freeShippingPersonaNudge",
  },
  {
    optionName: "Geo Location",
    optionValue: "geoLocationPersonaNudge",
  },
  {
    optionName: "Most Recent Visit Item",
    optionValue: "mostRecentVisitItemPersonaNudge",
  },
  {
    optionName: "Multi Item",
    optionValue: "multiItemPersonaNudge",
  },
];

export const userPersonaTypes = [
  {
    optionName: "First Time",
    optionValue: "firstTimePersonaNudge",
  },
];

// export const defaultNudgeValue = {
//   nudgeOfferText: {
//     text: "Get an exclusive 14% off, Order within 3:45:25 hours!",
//     textColor: "#000000",
//     backgroundColor: "#ffffff",
//     fontStyle: "normal",
//   },
//   nudgeCouponCode: {
//     text: "DISCOUNT40",
//     textColor: "#000000",
//     backgroundColor: "#ffffff",
//     fontStyle: "normal",
//     borderStyle: "none",
//   },
//   nudgeCopyCode: {
//     text: "COPY CODE",
//     textColor: "#000000",
//     backgroundColor: "#ffffff",
//     fontStyle: "italic",
//     borderStyle: "none",
//   },
//   nudge: {
//     backgroundColor: "#ffffff",
//     borderColor: "#ffffff",
//     borderStyle: "none",
//   },
// };

// multiple nudges
// exploratoryPersonaNudge: { ...subOptions },
//   firstTimePersonaNudge: { ...subOptions },
//   upsellPersonaNudge: { ...subOptions },
//   upsell2PersonaNudge: { ...subOptions },
//   b2BPersonaNudge: { ...subOptions },
//   freeShippingPersonaNudge: { ...subOptions },
//   geoLocationPersonaNudge: { ...subOptions },
//   mostRecentVisitItemPersonaNudge: { ...subOptions },
//   multiItemPersonaNudge: { ...subOptions },
